<template>
  <div>
    <!--Coupons-->
    <shop-header :store-id="storeid" />
    <section
      class="bg-white desktop-menu"
      :class="{ 'position-sticky': !activePopup }"
      style="top: -1px; z-index: 2"
    >
      <div class="container-fluid" :style="getNavbarStyles()">
        <div class="container" ref="container" v-if="storeMenu">
          <resturant-menu :categories="storeMenu.Categories" />
        </div>
      </div>
    </section>
    <div class="container root">
      <div class="row main-container" v-if="storeMenu && currentStoreDoc">
        <main :class="computeProductListClass">
          <ProductList
            :menu="setMenu()"
            @update-containerWidth="(p) => updateWidth(p)"
          />
        </main>
        <aside
          v-if="!isDigitalDisplay"
          :class="shoppingCartClass"
          id="shopping-cart"
          :style="getShoppingCartStyles()"
        >
          <div
            id="aside-top"
            class="category-title"
            v-if="storeMenu.Categories && storeMenu.Categories.length > 0"
          />
          <ShoppingCart :isFromHomePage="true" />
        </aside>
      </div>
    </div>
    <shopfooter v-if="storeMenu" />
    <order-type v-if="showOrderTypePopup"></order-type>
    <enter-name v-if="showEnterNamePopUp && showSharedCart" />
    <guest-count v-if="showGuestCount" />
    <order-placed v-if="getModalProp" />
  </div>
</template>
<script>
import ProductList from "./products/ProductList";
import ShoppingCart from "./shopping-cart/ShoppingCart";
import ResturantMenu from "./../shared/menu";
import ShopHeader from "./partials/shopheader";
import shopfooter from "./../shared/shopfooter";
import { mapMutations, mapActions, mapGetters } from "vuex";
import OrderType from "./OrderType";
import { orderTypeHelper } from "../../api/helpers/orderTypeHelper";
import { CONSTANT_ORDER_TYPE_DINEIN } from "../../constants/strings";
import GuestCount from "./GuestCount.vue";

import EnterName from "../user/EnterName.vue";
import OrderPlaced from "../shared/OrderPlaced.vue";
export default {
  components: {
    ProductList,
    ShoppingCart,
    ResturantMenu,
    ShopHeader,
    shopfooter,
    OrderType,
    EnterName,
    OrderPlaced,
    GuestCount,
  },
  props: {
    storeid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      productListClass: "col-xl-8 col-md-7 col-sm-6",
      shoppingCartClass: "col-xl-4 col-md-5 col-sm-6",
      showOrderTypeSelection: false,
      multipleMenus: true,
    };
  },
  async created() {
    if (
      this.currentStoreDoc &&
      this.currentStoreDoc.ViewComponentConfigs &&
      this.currentStoreDoc.ViewComponentConfigs.MultipleMenus === false
    ) {
      this.multipleMenus = false;
    }
    if (this.showSharedCart) {
      this.getTableOrder(this.storeid);
    }
    if (this.$route.query.table) {
      orderTypeHelper.setOrderTypeDineIn();
      this.setSelectedMenuType(CONSTANT_ORDER_TYPE_DINEIN);
    }
  },
  computed: {
    ...mapGetters([
      "activePopup",
      "storeMenu",
      "desktopStyles",
      "isDigitalDisplay",
      "currentStoreDoc",
      "showSharedCart",
      "getModalProp",
      "showGuestCount",
      "storeClosed",
    ]),
    computeProductListClass() {
      if (this.isDigitalDisplay) {
        return "col-xl-12 col-md-12 col-sm-12";
      } else {
        return this.productListClass;
      }
    },
    showOrderTypePopup() {
      return (
        this.multipleMenus && !this.$route.query.table && !this.storeClosed
      );
    },
    showEnterNamePopUp() {
      return this.$route.query.table;
    },
  },
  mounted() {
    this.setStore(this.storeid);
    this.setShowDeliveryFee(true);
    this.updateShoppingCartItems();
  },
  methods: {
    ...mapMutations([
      "setStore",
      "setStoreLoaded",
      "setShowDeliveryFee",
      "setSelectedMenuType",
    ]),
    ...mapActions([
      "getStoreMenu",
      "updateShoppingCartItems",
      "initPayTable",
      "getTableOrder",
    ]),
    setMenu() {
      return JSON.parse(JSON.stringify(this.storeMenu));
    },
    updateWidth(width) {
      if (width > 992) {
        this.productListClass = "col-xl-8 col-md-7 col-sm-6";
        this.shoppingCartClass = "col-xl-4 col-md-5 col-sm-6";
      } else {
        this.productListClass = "col-xl-6 col-md-6 col-sm-6";
        this.shoppingCartClass = "col-xl-6 col-md-6 col-sm-6";
      }
    },
    getNavbarStyles() {
      var styles = [];
      if (this.isRolldStore()) {
        styles.push(this.desktopStyles.primaryBodyBackground);
      } else {
        styles.push(this.desktopStyles.nav);
      }
      return styles;
    },
    getShoppingCartStyles() {
      var styles = [];
      if (this.isRolldStore()) {
        styles.push({
          "padding-left": "0px !important",
        });
      }
      return styles;
    },
  },
};
</script>
